import * as actionTypes from "../actions/actionTypes";

const initialState = {
  data: null,
};

export default (state = initialState, action = {}) => {

  switch (action.type) {
    case actionTypes.CHANGE_NOTIFICATION_NOW:
      return {
        ...state,
        data: action.msg,
      };

    default:
      return state;
  }
};
